{
    "close": "關閉",
    "copy": "複製",
    "delete": "刪除",
    "edit": "編輯",
    "collapse": "收合",
    "expand": "展開",
    "filter": "篩選",
    "history": "紀錄",
    "more": "更多",
    "refresh": "重新整理",
    "view": "查看",
    "staleApp": {
        "bannerMessage": "有新版本，完成目前操作後請重新整理",
        "panelTitle": "頁面已更新",
        "goBack": "返回上一頁"
    },
    "pagination": {
        "rowsPerPageLabel": "每頁筆數",
        "rowsPerPage": "每頁 {{count}} 筆",
        "summary": "第 {{page}} / {{totalPages}} 頁，共 {{count}} 筆",
        "previous": "上一頁",
        "next": "下一頁"
    }
}
